import React from 'react';
import { SparklineChart } from '../../../common-components/charts/SparklineChart';

export default function Sparkline({
  values,
  labels,
  height = 32,
  width = 120,
}: {
  values: number[];
  labels?: string[];
  height?: number;
  width?: number;
}) {
  return <SparklineChart values={values} labels={labels} height={height} maxWidth={width} />;
}

